import { useQuery } from '@tanstack/react-query';
import type {
  SearchLabTestsRequestT,
  SearchLabTestsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSearchLabTests } from '../api/searchLabTests.js';
import { labsKeys } from './keys.js';

export function searchLabTestsQueryDefinition(filters: SearchLabTestsRequestT) {
  return {
    queryKey: labsKeys.labTestsSearch(filters),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSearchLabTests(filters, signal),
  } as const;
}

export function useSearchLabTestsQuery(filters: SearchLabTestsRequestT | undefined) {
  return useQuery({
    queryKey: filters
      ? labsKeys.labTestsSearch(filters)
      : (['labs', 'tests', 'search', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<SearchLabTestsResponseT> => {
      if (!filters) {
        throw new Error('Missing lab test search filters');
      }
      return fetchSearchLabTests(filters, signal);
    },
    enabled: !!filters,
  });
}
